import { sync } from "vuex-pathify"

export default {
  computed: {
    includedRetention: {
      get() {
        return Math.floor(this.includedRetentionSeconds / 86400)
      },
      set(val) {
        this.includedRetentionSeconds = val * 86400
      },
    },
    includedSource: {
      get() {
        return this.includedEventSources[0]
      },
      set(val) {
        this.includedEventSources = [val]
      },
    },
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    if (!this.$options.computed) {
      this.$options.computed = {}
    }

    Object.assign(this.$options.computed, {
      ...sync(
        `${storeNamespace}/model@audience.template.rule.inclusions.rules[0]`,
        {
          includedEventSources: "eventSources",
          includedRetentionSeconds: "retentionSeconds",
        }
      ),
      ...sync(
        `${storeNamespace}/model@audience.template.rule.inclusions.rules[0].filter.filters[0]`,
        {
          includedPage: "value",
        }
      ),
    })
  },
}
